import React, {Component} from 'react';
import {Route, Switch, Redirect} from "react-router-dom";

import Magnet from "../Magnet";

import SideMenu from "../../components/SideMenu";
import Header from "../../components/Header";
import Scrollbar from "../../components/Scrollbar";
import AuthProvider from "../../components/AuthProvider";

import {healthServicesName} from "../../helpers/utils";

export class AppRoot extends Component {

    render() {
        const {history} = this.props;
        const {pathname} = history.location;
        const healthServiceName = healthServicesName[pathname];

        return (
            <AuthProvider>
                <div className="app-root">
                    <SideMenu/>
                    <div className="app-root-body">
                        <Scrollbar>
                            <div className="app-root-scroll">
                                <Header healthServiceName={healthServiceName}/>
                                <Switch>
                                    <Route path={`/sales`} render={props => <Magnet account={1} {...props}/>}/>
                                    <Route path={`/vendors`} render={props => <Magnet account={2} {...props}/>}/>

                                    <Redirect from="/" to="/sales" exact />
                                </Switch>
                            </div>
                        </Scrollbar>
                      </div>
                </div>
            </AuthProvider>
        );
    }
}

export default (AppRoot);
